module.exports = __webpack_public_path__ + "img/swag-admin-2.d81bb78c.png";